// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .skeleton-content {
  display: flex;
  flex-flow: column nowrap;
  row-gap: 10px;
}
:host .skeleton-content .message-card-skeleton {
  width: 100%;
  height: 108px;
  margin: 0;
  --border-radius: var(--radius-xl);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skeleton-messages/skeleton-messages.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,wBAAA;EACA,aAAA;AAAR;AAEQ;EACI,WAAA;EACA,aAAA;EACA,SAAA;EACA,iCAAA;AAAZ","sourcesContent":[":host {\r\n    .skeleton-content {\r\n        display: flex;\r\n        flex-flow: column nowrap;\r\n        row-gap: 10px;\r\n\r\n        .message-card-skeleton {\r\n            width: 100%;\r\n            height: 108px;\r\n            margin: 0;\r\n            --border-radius: var(--radius-xl);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
